import { injectIntl } from 'react-intl';
import Copy from './Copy';

export default injectIntl(Copy);
